'use strict';

angular.module('adelementAdminApp')
    .factory('UserAdvertiserMapping', function ($resource, DateUtils) {
        return $resource('api/userAdvertiserMappings/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    });
